import { promoActivatedRewardStorageKey } from 'pi-kiosk-shared/promo/promoSessionHandoff';

export function readActivatedPromoRewardHandoff(
  tenantCode: string,
  checkoutSessionId: string | null | undefined,
): string | null {
  if (checkoutSessionId == null || checkoutSessionId.trim().length === 0) {
    return null;
  }
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  try {
    const value = sessionStorage.getItem(
      promoActivatedRewardStorageKey(tenantCode, checkoutSessionId),
    );
    return value != null && value.length > 0 ? value : null;
  } catch {
    return null;
  }
}
